var map = {
	"./amex.svg": 17518,
	"./diners.svg": 75604,
	"./discover.svg": 8052,
	"./jcb.svg": 76500,
	"./mastercard.svg": 27943,
	"./unionpay.svg": 58790,
	"./visa.svg": 1964
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84769;